import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider, useTheme, Topbar, PageHeader, LoadingScreen, EmptyState } from '../shared/DashWidgets';
import Sidebar from '../shared/Sidebar';
import { buildStyles, COLORS } from '../shared/DashTheme';
import api from '../../services/api';

function ProfileModal({ user, onClose, s }) {
  const isUni = user.authority_type === 'university';
  const color = isUni ? '#a5b4fc' : COLORS.amber;
  const bgA = isUni ? 'rgba(99,102,241,' : 'rgba(245,158,11,';
  const rows = [
    { label: 'Email',      value: user.email },
    { label: 'Type',       value: isUni ? 'University Authority' : 'Department Authority' },
    { label: 'Department', value: user.department || (isUni ? 'All Departments' : '\u2014') },
    { label: 'Status',     value: user.is_active === false ? 'Inactive' : 'Active' },
    { label: 'Joined',     value: user.created_at
        ? new Date(user.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
        : '\u2014' },
  ];
  const negligence = user.negligence_count ?? 0;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}
      onClick={onClose}>
      <div style={{ ...s.card, width: '100%', maxWidth: 420, padding: 0,
          overflow: 'hidden', animation: 'scaleIn 0.2s ease-out' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ padding: '24px 24px 18px',
            background: `linear-gradient(135deg,${bgA}0.13),${bgA}0.05))`,
            borderBottom: `1px solid ${bgA}0.3)`, position: 'relative' }}>
          <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 12,
              background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: 8, color: '#fff', cursor: 'pointer', width: 28, height: 28,
              fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            \u00d7
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%',
                background: `${bgA}0.35)`, border: `2px solid ${bgA}0.5)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22, fontWeight: 900, color: '#fff', flexShrink: 0 }}>
              {user.name?.[0]?.toUpperCase() || '?'}
            </div>
            <div>
              <div style={{ fontSize: 17, fontWeight: 800, color: '#fff' }}>{user.name}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>{user.email}</div>
              <div style={{ display: 'flex', gap: 6, marginTop: 7, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                    background: `${bgA}0.25)`, color: color, border: `1px solid ${bgA}0.4)` }}>
                  &#11088; AUTHORITY
                </span>
                <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                    background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.7)',
                    border: '1px solid rgba(255,255,255,0.2)' }}>
                  {(user.authority_type || '').toUpperCase()}
                </span>
                {negligence > 0 && (
                  <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                      background: 'rgba(239,68,68,0.25)', color: '#fca5a5',
                      border: '1px solid rgba(239,68,68,0.4)' }}>
                    &#9888; {negligence} NEGLIGENCE
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          {[
            { label: 'Resolved',   value: user.resolved_count   ?? 0, color: COLORS.green },
            { label: 'Assigned',   value: user.assigned_count   ?? 0, color: COLORS.cyan  },
            { label: 'Negligence', value: negligence,                  color: negligence > 0 ? '#f87171' : 'rgba(255,255,255,0.3)' },
          ].map(st => (
            <div key={st.label} style={{ flex: 1, padding: '12px 0', textAlign: 'center',
                borderRight: '1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ fontSize: 20, fontWeight: 800, color: st.color }}>{st.value}</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginTop: 2,
                  textTransform: 'uppercase', letterSpacing: 0.5 }}>{st.label}</div>
            </div>
          ))}
        </div>
        <div style={{ padding: '16px 24px 22px' }}>
          {rows.map(({ label, value }) => (
            <div key={label} style={{ display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', padding: '8px 0',
                borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
              <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', fontWeight: 600,
                  textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</span>
              <span style={{ fontSize: 13, color: '#fff', fontWeight: 600,
                  maxWidth: 220, textAlign: 'right', wordBreak: 'break-all' }}>{value}</span>
            </div>
          ))}
          {negligence > 0 && (
            <div style={{ marginTop: 12, padding: '7px 12px', borderRadius: 8,
                background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)',
                fontSize: 12, color: '#fca5a5', display: 'flex', alignItems: 'center', gap: 8 }}>
              &#9888; {negligence} negligence flag{negligence !== 1 ? 's' : ''} recorded
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ManageAuthoritiesInner() {
  const { theme } = useTheme();
  const s = buildStyles(theme);
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  React.useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  const [authorities, setAuthorities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [deleting, setDeleting] = useState(null);
  const [selected, setSelected] = useState(null);

  const fetchAuthorities = async () => {
    try {
      const res = await api.get('/higher-authority/authorities');
      setAuthorities(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to load authorities');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAuthorities(); }, []);

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Deactivate this authority member?')) return;
    setDeleting(id);
    try {
      await api.delete(`/higher-authority/delete-authority/${id}`);
      setAuthorities(prev => prev.filter(a => a.id !== id));
    } catch (e2) {
      setError(e2.response?.data?.error || 'Failed to deactivate');
    } finally {
      setDeleting(null);
    }
  };

  if (loading) return <LoadingScreen />;

  const uniAuths  = authorities.filter(a => a.authority_type === 'university');
  const deptAuths = authorities.filter(a => a.authority_type === 'department');

  const AuthCard = ({ auth }) => {
    const isUni = auth.authority_type === 'university';
    const negligence = auth.negligence_count ?? 0;
    return (
      <div className="ur-card-hover" onClick={() => setSelected(auth)}
        style={{ ...s.card, display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', padding: '12px 16px', marginBottom: 10, cursor: 'pointer' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 38, height: 38, borderRadius: '50%',
              background: isUni ? 'rgba(99,102,241,0.3)' : 'rgba(245,158,11,0.3)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
            {auth.name?.[0]?.toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>{auth.name}</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>{auth.email}</div>
            {auth.department && (
              <div style={{ fontSize: 11, color: COLORS.cyan, marginTop: 2 }}>{auth.department}</div>
            )}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          {negligence > 0 && (
            <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                background: 'rgba(239,68,68,0.25)', color: '#fca5a5',
                border: '1px solid rgba(239,68,68,0.4)' }}>
              &#9888; {negligence} negligence
            </span>
          )}
          <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
              background: isUni ? 'rgba(99,102,241,0.25)' : 'rgba(245,158,11,0.25)',
              color: isUni ? '#a5b4fc' : '#fcd34d',
              border: `1px solid ${isUni ? 'rgba(99,102,241,0.4)' : 'rgba(245,158,11,0.4)'}` }}>
            {isUni ? 'UNIVERSITY' : 'DEPARTMENT'}
          </span>
          <button className="ur-btn-hover"
            style={{ ...s.btnPrimary, fontSize: 11, padding: '4px 10px',
              background: 'rgba(239,68,68,0.3)', border: '1px solid rgba(239,68,68,0.5)',
              opacity: deleting === auth.id ? 0.6 : 1 }}
            onClick={e => handleDelete(auth.id, e)} disabled={deleting === auth.id}>
            {deleting === auth.id ? '...' : 'Deactivate'}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div style={s.page}>
      <div style={s.bgGrid} /><div style={s.bgOrb1} /><div style={s.bgOrb2} /><div style={s.bgOrb3} />
      <div style={s.layout}>
        <Sidebar collapsed={!sidebarOpen} onToggle={() => setSidebarOpen(o => !o)} mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
        <div style={{ ...s.main, marginLeft: isMobile ? 0 : (sidebarOpen ? 248 : 0), transition: 'margin-left 0.3s ease' }}>
          <Topbar title="Manage Authorities"
            subtitle={`${authorities.length} active authority members`}
            onToggleSidebar={() => setSidebarOpen(o => !o)}
            onMobileMenu={() => setMobileOpen(true)}
            actions={
              <button className="ur-btn-hover" style={s.btnPrimary}
                onClick={() => navigate('/higher-authority/create-authority')}>
                + Create Authority
              </button>
            }
          />
          <div style={s.content}>
            <PageHeader icon="★" title="Manage Authorities"
              stats={[
                { label: 'University', value: uniAuths.length },
                { label: 'Department', value: deptAuths.length },
              ]}
            />
            {error && <div style={{ ...s.alertErr, marginBottom: 16 }}>{error}</div>}
            {!authorities.length
              ? <EmptyState text="No authority members yet" sub="Create your first authority member" />
              : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 20 }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#a5b4fc', marginBottom: 12,
                        textTransform: 'uppercase', letterSpacing: 0.8 }}>
                      University Authorities ({uniAuths.length})
                    </div>
                    {uniAuths.length
                      ? uniAuths.map(a => <AuthCard key={a.id} auth={a} />)
                      : <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', fontStyle: 'italic' }}>None yet</div>
                    }
                  </div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#fcd34d', marginBottom: 12,
                        textTransform: 'uppercase', letterSpacing: 0.8 }}>
                      Department Authorities ({deptAuths.length})
                    </div>
                    {deptAuths.length
                      ? deptAuths.map(a => <AuthCard key={a.id} auth={a} />)
                      : <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', fontStyle: 'italic' }}>None yet</div>
                    }
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
      {selected && <ProfileModal user={selected} onClose={() => setSelected(null)} s={s} />}
    </div>
  );
}

export default function ManageAuthorities() {
  return <ThemeProvider><ManageAuthoritiesInner /></ThemeProvider>;
}
